import { isPlainObject } from "lodash";
import { showEasyNotification } from "@/src/easy-ui/main";
import { GraphQLFormattedError } from "graphql/index";
import { NotificationSettings } from "@/src/shared/types/notify";
import { EasyAlerts } from "@/src/easy-ui/types";

export const notifyErrorFromResponse = function (
  config: { message: string } | string[] | ReadonlyArray<GraphQLFormattedError>
): void {
  if (isPlainObject(config)) {
    openNotification(config as { message: string });
  } else {
    const errors = config as string[];
    errors?.forEach(error => {
      showEasyNotification({ message: error });
    });
  }
};

export const openNotification = function (config: {
  message?: string;
  description?: string | string[];
  type?: string;
  cancelable?: boolean;
}): void {
  const { message, description, type } = config || {};
  const isDescriptionArray = Array.isArray(description);
  const responses = isDescriptionArray ? description : [description];
  responses?.forEach(response => {
    showEasyNotification({ type: type as EasyAlerts, title: message, message: response });
  });
};

export const notify = function ({ type = "success", message = "Successful update", ...args }: NotificationSettings) {
  showEasyNotification({ type: type as EasyAlerts, title: message, ...args });
};
